import { BlocksAnchorNavItem } from 'blocks-nextjs/blocks-web-components/components/anchor-nav-item/anchor-nav-item';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatAnchorNavItem = createComponent({ react: React, tagName: 'cat-anchor-nav-item', elementClass: BlocksAnchorNavItem });
